<template>
	<div class="vx-row" v-if="isForm">
		<div :class="cssClazz">
			<vs-select autocomplete class="w-full" v-model="value" :disabled="disabled">
				<vs-select-item
					:key="index"
					:value="item.id"
					:text="item.name"
					v-for="(item,index) in schema.refValue"
				/>
			</vs-select>
		</div>
	</div>
	<vs-col vs-justify="center" vs-align="center" :vs-w="colw" v-else>
		<div class="vx-row md:mt-2 lg:mt-2">
			<vs-col class="sm:w-full md:w-11/12 lg:w-11/12">
				<vs-select autocomplete class="w-full" v-model="value" :disabled="disabled">
					<vs-select-item
						:key="index"
						:value="item.id"
						:text="item.name"
						v-for="(item,index) in schema.refValue"
					/>
				</vs-select>
			</vs-col>
		</div>
	</vs-col>
</template>

<script>
import VueFormGenerator from "vue-form-generator";

export default {
	data() {
		return {
			danger: false,
			dangerText: "",
			cssClazz:
				"vx-col w-full sm:w-full md:w-full mt-2 mb-2 lg:w-1/2 mt-2 mb-2",
			isForm: true,
			colw: 6
		};
	},
	methods: {},
	mounted() {
		if (
			typeof this.schema.cols !== undefined &&
			this.schema.cols == true
		) {
			this.isForm = false;
		}
	},
	mixins: [VueFormGenerator.abstractField]
};
</script>
